{
    "francois": {
        "key": "francois",
        "position": {
            "x": -1,
            "y": 5,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/paladin",
        "moverange": 3,
        "maxhealth": 50
    },
    "#B": {
        "key": "#B",
        "position": {
            "x": -1,
            "y": 4,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/rogue",
        "maxhealth": "30"
    },
    "#C": {
        "key": "#C",
        "position": {
            "x": -1,
            "y": 1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "#D": {
        "key": "#D",
        "position": {
            "x": 5,
            "y": -1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    }
}
